import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AuthHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (code) {
      const fetchToken = async () => {
        try {
          const response = await fetch("https://connexions-narratives.online/auth/realms/master/protocol/openid-connect/token", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              client_id: "weavevo-frontend",
              grant_type: "authorization_code",
              code,
              redirect_uri: "https://connexions-narratives.online/auth/callback", 
            }),
          });

          if (!response.ok) throw new Error("Erreur échange code/token");

          const data = await response.json();
          const token = data.access_token;
          const payload = JSON.parse(atob(token.split(".")[1]));

          login(token, {
            name: payload.name,
            email: payload.email,
          });

          navigate("/dashboard");
        } catch (err) {
          console.error("Erreur Google Login:", err);
          navigate("/login");
        }
      };

      fetchToken();
    }
  }, [location.search, login, navigate]);

  return <div>Connexion en cours...</div>;
};

export default AuthHandler;
